var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "l-zoom cl-blue" }, [
    _c(
      "a",
      {
        staticClass: "u-col",
        on: {
          click: function($event) {
            return _vm.zoom(1)
          }
        }
      },
      [_c("icon-plus")],
      1
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "u-col",
        on: {
          click: function($event) {
            return _vm.zoom(-1)
          }
        }
      },
      [_c("icon-minus")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }